<script>
  import InputContainer from '@components/inputs/input-container.svelte'
  import { Mail, CircleCheck, TriangleAlert, Circle } from 'lucide-svelte'

  let { value = $bindable(""), validate = "blur", ...inputProps } = $props()

  let valid = $state(true)

</script>

<InputContainer bind:value type="email" onValidate={v => valid = v} {validate} {...inputProps}>
  {#snippet prefix()}
    <Mail size={14} class="text-gray-400" />
  {/snippet}

  {#snippet suffix()}
    {#if !validate}
      <Circle size={14} class="text-gray-300" strokeWidth={1.5} />
    {:else if value.length === 0}
      <CircleCheck size={14} class="text-gray-400" strokeWidth={1.5} />
    {:else if valid}
      <CircleCheck size={14} class="text-green-600" strokeWidth={1.5} />
    {:else}
      <TriangleAlert size={14} class="text-gray-400" strokeWidth={1.5} />
    {/if}
  {/snippet}
</InputContainer>
